var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.options,"dense":"","filled":"","hide-details":"auto","label":_vm.label},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})}
var staticRenderFns = []

export { render, staticRenderFns }